import { Box, Paper } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Layout, LoginLogoImg } from '@roc/feature-app-core';
import { StepObj, StepsContainer } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useStore } from '@roc/client-portal-shared/hooks';
import { BankInfoStep } from './bankInfoStep';
import { SignatureStep } from './signatureStep';
import { SummaryStep } from './summaryStep';
import { WelcomeStep } from './welcomeStep';
import { WireFraudNoticeStep } from './wireFraudNoticeStep';

const useStyles = makeStyles(theme =>
  createStyles({
    stepper: {
      maxWidth: 1000,
      margin: 'auto',
      '& .MuiStepLabel-completed': {
        color: theme.palette.primary.main,
      },
    },
    paper: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
    },
  })
);

export const WireInstructionsPage = observer(() => {
  const { encodedParams } = useParams<{ encodedParams: string }>();
  const [showWelcome, setShowWelcome] = useState(true);
  const classes = useStyles();
  const { wireInstructionsStore } = useStore() as any;
  const store = wireInstructionsStore;

  useEffect(() => {
    if (encodedParams) {
      store.fetchData(encodedParams);
    }
  }, [encodedParams]);

  // Once data is loaded, skip the welcome screen if the form was already
  // submitted in a previous visit (the store lands on the summary step).
  useEffect(() => {
    if (store.loanData && store.submitted) {
      setShowWelcome(false);
    }
  }, [store.loanData, store.submitted]);

  const steps: StepObj[] = [
    {
      title: 'Wire Fraud Notice',
      icon: null,
      completed: store.activeStep > 0,
    },
    {
      title: 'Bank Information',
      icon: null,
      completed: store.activeStep > 1,
    },
    {
      title: 'DocuSign Confirmation',
      icon: null,
      completed: store.activeStep > 2,
    },
    {
      title: 'Summary',
      icon: null,
      allowBack: false,
    },
  ] as unknown as StepObj[];

  return (
    <Layout maxWidth="lg">
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <LoginLogoImg imgStyle={{ width: '150px' }} />
      </Box>
      {showWelcome ? (
        <WelcomeStep store={store} onStart={() => setShowWelcome(false)} />
      ) : (
        <Paper className={classes.paper}>
          <StepsContainer
            disableNavigation={true}
            activeStep={store.activeStep}
            handleStep={step => store.setActiveStep(step)}
            steps={steps}
            stepperClassName={classes.stepper}
          >
            <WireFraudNoticeStep store={store} onContinue={() => store.setActiveStep(1)} />
            <BankInfoStep store={store} onContinue={() => store.setActiveStep(2)} />
            <SignatureStep store={store} />
            <SummaryStep store={store} />
          </StepsContainer>
        </Paper>
      )}
    </Layout>
  );
});
